import { Box, Stack, SxProps } from '@mui/material';
import Optional from '../../../Optional';
import RichText, { RichTextContent } from '../../../RichText';

export type TitleProps = {
  title?: RichTextContent;
  subtitle?: RichTextContent;
  sx?: SxProps;
};

const Titles = ({ title, subtitle, sx }: TitleProps) => {
  return (
    <Box
      sx={{
        overflowY: 'auto',
        '&::-webkit-scrollbar': { display: 'none' },
      }}
    >
      <Stack
        spacing={2}
        sx={{
          justifyContent: 'end',
          ...sx,
        }}
      >
        <RichText
          withTypography
          color={'textPrimary'}
          variant={'subtitle1'}
          component={'h3'}
          sx={{ pb: 1 }}
        >
          {title}
        </RichText>
        <Optional condition={!!subtitle}>
          <RichText withTypography color={'textSecondary'} variant={'body2'}>
            {subtitle}
          </RichText>
        </Optional>
      </Stack>
    </Box>
  );
};

export default Titles;
